import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconPackageValidation from '@/icons/PackageValidation.svg';

export const ArticleTransitValidatedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_transit_validated'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator?.name;
  const trackingId = activity.data.trackingId;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconPackageValidation />}
      message={
        <>
          <BaseActivityText>
            <Trans id="activities.article_transit_validated.message">
              <strong>{creatorName}</strong> validated the transit of the item{' '}
            </Trans>
            <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />{' '}
            {!!trackingId && (
              <Trans id="activities.article_transit_validated.message.tracking_number">
                with tracking number: <strong>{trackingId}</strong>{' '}
              </Trans>
            )}
            .
          </BaseActivityText>
        </>
      }
    />
  );
};
